(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-link-whatsapp"] && !Shopify.designMode) return;
  try {
    // Rebuilds the WhatsApp href whenever the variant picker changes, so [price],
  // [sku], [variant] and the ?variant= id inside [url] describe the variant actually
  // on screen rather than whichever one Liquid rendered first.
  //
  // Prices arrive pre-formatted from the `money` filter in the variant map. There is
  // deliberately no money formatting in here to drift out of step with the store's
  // own currency format.
  (function () {
    function readJSON(el, attr) {
      try {
        return JSON.parse(el.getAttribute(attr) || 'null');
      } catch (e) {
        return null;
      }
    }

    function apply(el, variant) {
      var phone = el.getAttribute('data-wa-phone');
      // No number on the block or in theme settings: Liquid already rendered this as
      // an aria-disabled link with no href. Leave it that way rather than pointing
      // WhatsApp at nothing.
      if (!phone) return;

      var baseUrl = el.getAttribute('data-wa-url') || '';
      var url = variant && variant.id ? baseUrl + '?variant=' + variant.id : baseUrl;

      // split/join rather than replace, so a token used twice is handled and none of
      // the merchant's text needs regex escaping.
      var message = (el.getAttribute('data-wa-message') || '')
        .split('[product]').join(el.getAttribute('data-wa-product') || '')
        .split('[url]').join(url)
        .split('[price]').join((variant && variant.price) || '')
        .split('[sku]').join((variant && variant.sku) || '')
        .split('[variant]').join((variant && variant.title) || '');

      // encodeURIComponent renders a space as %20, matching the Liquid side.
      el.setAttribute('href', 'https://api.whatsapp.com/send?phone=' + phone + '&text=' + encodeURIComponent(message));
    }

    function onVariantChange(event) {
      var data = event && event.data;
      if (!data || !data.variant) return;

      var links = document.querySelectorAll('[data-wa-link]');
      Array.prototype.forEach.call(links, function (el) {
        // A page can host more than one product form; only react to our own section.
        if (el.getAttribute('data-wa-section') !== String(data.sectionId || '')) return;

        var map = readJSON(el, 'data-wa-variants') || [];
        var match = null;
        for (var i = 0; i < map.length; i++) {
          if (String(map[i].id) === String(data.variant.id)) {
            match = map[i];
            break;
          }
        }

        // A variant added since this page was rendered is missing from the map. The
        // event still carries enough to stay useful — only the formatted price is lost.
        apply(el, match || {
          id: data.variant.id,
          title: data.variant.title,
          sku: data.variant.sku,
          price: ''
        });
      });
    }

    // Guarded the way assets/gift-packaging-theme-gate.js guards it: vendor.js
    // defines both globals, but block JS can evaluate before it on some pages.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["form-builder"] && !Shopify.designMode) return;
  try {
    // Client behaviour for the form builder. On submit it does two additive things
  // and never calls preventDefault, so the native Shopify contact post — and the
  // notification email it triggers — happens exactly as it would without JS:
  //
  //   1. POSTs the submission to the merchant's endpoint (fire and forget).
  //   2. Stashes the entered values so they can be restored if Shopify rejects
  //      the submission. This is needed because Shopify's `form` object is not in
  //      scope inside the field sub-blocks, so the values cannot be re-rendered
  //      server-side the way a single-file contact form would.
  //
  // The analytics event is published later still — on the reload that renders the
  // success message. By then Shopify has accepted the submission, so unlike the
  // endpoint POST above, a submission Shopify rejects never counts as a conversion.
  (function () {
    function stashKey(form) {
      return 'fb:' + (form.id || 'form');
    }

    function clearStash(form) {
      try {
        sessionStorage.removeItem(stashKey(form));
      } catch (e) {
        /* private mode */
      }
    }

    // Only merchant-defined fields. Drops the internals Shopify injects
    // (form_type, utf8, h-captcha-response) and our own routing input.
    function fields(form) {
      return Array.prototype.filter.call(form.elements, function (el) {
        if (!el.name || el.name.indexOf('contact[') !== 0) return false;
        if (el.name === 'contact[id]') return false;
        var type = (el.type || '').toLowerCase();
        return type !== 'submit' && type !== 'button';
      });
    }

    function label(el) {
      return el.name.replace(/^contact\[/, '').replace(/\]$/, '');
    }

    function postToEndpoint(wrap, form) {
      var url = wrap.getAttribute('data-fb-endpoint');
      if (!url) return;

      // Assigning into an object rather than appending to URLSearchParams makes
      // later values win, matching how the browser posts the form. That is what
      // lets a ticked checkbox override the paired hidden "No" input.
      var data = {};
      fields(form).forEach(function (el) {
        var type = (el.type || '').toLowerCase();
        if ((type === 'checkbox' || type === 'radio') && !el.checked) return;
        data[label(el)] = el.value;
      });

      var params = new URLSearchParams();
      Object.keys(data).forEach(function (key) {
        params.append(key, data[key]);
      });
      params.append('form_name', wrap.getAttribute('data-fb-name') || '');
      params.append('form_id', form.id || '');
      params.append('page_url', window.location.href);
      params.append('page_title', document.title);
      params.append('shop', window.location.host);
      params.append('submitted_at', new Date().toISOString());

      // keepalive requests are capped at ~64KB per origin. The native email still
      // carries everything, so warn rather than fail.
      if (params.toString().length > 60000) {
        console.warn('[form-builder] payload is large and may exceed the 64KB keepalive limit');
      }

      // no-cors means the endpoint needs zero CORS setup; the response is opaque
      // and deliberately unread.
      try {
        fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true, body: params }).catch(function (e) {
          console.warn('[form-builder] endpoint POST failed', e);
        });
      } catch (e) {
        console.warn('[form-builder] endpoint POST threw', e);
      }
    }

    function stash(form) {
      try {
        var saved = fields(form).map(function (el) {
          return { n: el.name, v: el.value, t: (el.type || '').toLowerCase(), c: !!el.checked };
        });
        sessionStorage.setItem(stashKey(form), JSON.stringify(saved));
      } catch (e) {
        /* quota or private mode — repopulation is a nicety, not critical */
      }
    }

    function restore(form) {
      var raw;
      try {
        raw = sessionStorage.getItem(stashKey(form));
      } catch (e) {
        return;
      }
      if (!raw) return;

      var saved;
      try {
        saved = JSON.parse(raw);
      } catch (e) {
        clearStash(form);
        return;
      }
      if (!Array.isArray(saved)) return;

      var choices = {};
      var values = {};
      saved.forEach(function (entry) {
        if (entry.t === 'checkbox' || entry.t === 'radio') {
          choices[entry.n + '||' + entry.v] = entry.c;
        } else if (values[entry.n] === undefined) {
          values[entry.n] = entry.v;
        }
      });

      fields(form).forEach(function (el) {
        var type = (el.type || '').toLowerCase();
        if (type === 'checkbox' || type === 'radio') {
          var key = el.name + '||' + el.value;
          if (choices[key] !== undefined) el.checked = choices[key];
        } else if (type !== 'hidden' && values[el.name] !== undefined) {
          // Hidden inputs are merchant-fixed values and the checkbox "No" pair —
          // never overwrite them from the stash.
          el.value = values[el.name];
        }
      });

      clearStash(form);
    }

    // The stash doubles as the "did they just submit?" signal: it is written on
    // every submit and cleared here. A reload of the success page finds nothing, so
    // the conversion cannot be counted twice.
    function hadStash(form) {
      try {
        return sessionStorage.getItem(stashKey(form)) !== null;
      } catch (e) {
        return false;
      }
    }

    // Crosses into the Web Pixels sandbox, the only place the store's GA4 tag is
    // reachable from. Delivery depends on a pixel subscribing to this event —
    // publish resolves either way, so there is nothing here to report on failure.
    function publishSubmission(wrap, form) {
      if (!wrap.hasAttribute('data-fb-track')) return;

      var analytics = window.Shopify && window.Shopify.analytics;
      if (!analytics || typeof analytics.publish !== 'function') return;

      try {
        // Same shape as the endpoint payload above, so both sinks agree.
        var published = analytics.publish('form_builder:submitted', {
          form_name: wrap.getAttribute('data-fb-name') || '',
          form_id: form.id || '',
          page_url: window.location.href,
          page_title: document.title,
          submitted_at: new Date().toISOString()
        });

        // Documented as promise-returning in some contexts; an unhandled rejection
        // here would surface as a console error on an otherwise fine thank-you page.
        if (published && typeof published.catch === 'function') {
          published.catch(function (e) {
            console.warn('[form-builder] analytics publish rejected', e);
          });
        }
      } catch (e) {
        console.warn('[form-builder] analytics publish threw', e);
      }
    }

    function setup(wrap) {
      var form = wrap.querySelector('form');
      // Per-form guard: the theme editor re-runs section JS on every edit.
      if (!form || form.dataset.fbInit) return;
      form.dataset.fbInit = '1';

      if (form.querySelector('[data-fb-errors]')) restore(form);
      if (form.querySelector('[data-fb-success]')) {
        // Order matters — publishSubmission reads the stash that clearStash removes.
        if (hadStash(form)) publishSubmission(wrap, form);
        clearStash(form);
      }

      form.addEventListener('submit', function () {
        stash(form);
        postToEndpoint(wrap, form);
      });
    }

    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-form-builder]').forEach(setup);
    }

    init(document);
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
